import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IKuiDropdownMenuItem } from 'app/key-ui';
import { KuiDropdownComponent } from 'app/key-ui/dropdown/dropdown.component';

@Component({
    selector: 'key-details-ordered-list-item',
    templateUrl: './details-ordered-list-item.component.html',
    styleUrls: ['./details-ordered-list-item.component.scss'],
})
export class DetailsOrderedListItemComponent implements OnInit {

    @Input() name: string;
    @Input() value: string;
    @Input() isMobile = false;
    @Input() isPinned = false;

    @Output() pinned = new EventEmitter<string>();
    @Output() unPinned = new EventEmitter<string>();
    @Output() moveUp = new EventEmitter<string>();
    @Output() moveDown = new EventEmitter<string>();
    @Output() hidden = new EventEmitter<string>();

    @ViewChild('contextMenuRef', { static: true }) contextMenuRef: KuiDropdownComponent;

    contextMenu: IKuiDropdownMenuItem[] = [];

    private defaultContextOptions: IKuiDropdownMenuItem[] = [
        {
            id: 'up',
            text: this.i18n.instant('STATUS.DETAILS.SIDEBAR.ACTIONS.MOVE_UP'),
            type: 'action',
            closeDropdownOnClicked: true,
            action: () => {
                this.moveUp.emit(this.name);
            },
            icon: 'arrow-up',
        },
        {
            id: 'down',
            text: this.i18n.instant('STATUS.DETAILS.SIDEBAR.ACTIONS.MOVE_DOWN'),
            type: 'action',
            closeDropdownOnClicked: true,
            action: () => {
                this.moveDown.emit(this.name);
            },
            icon: 'arrow-down',
        },
    ];

    private unPinnedContextOptions: IKuiDropdownMenuItem[] = [
        {
            id: 'pin',
            text: this.i18n.instant('STATUS.DETAILS.SIDEBAR.ACTIONS.PIN'),
            type: 'action',
            closeDropdownOnClicked: true,
            action: () => {
                this.pinned.emit(this.name);
            },
            icon: 'thumbtack',
        },
        {
            id: 'hide',
            text: this.i18n.instant('STATUS.DETAILS.SIDEBAR.ACTIONS.HIDE'),
            type: 'action',
            closeDropdownOnClicked: true,
            action: () => {
                this.hidden.emit(this.name);
            },
            icon: 'eye-slash',
        },
    ];

    private pinnedContextOptions: IKuiDropdownMenuItem[] = [
        {
            id: 'unpin',
            text: this.i18n.instant('STATUS.DETAILS.SIDEBAR.ACTIONS.UNPIN'),
            type: 'action',
            closeDropdownOnClicked: true,
            action: () => {
                this.unPinned.emit(this.name);
            },
            icon: 'thumbtack',
        },
    ];

    constructor(
        public i18n: TranslateService,
        private elRef: ElementRef
    ) { }

    ngOnInit() {
        this.contextMenu = this.isPinned ? this.pinnedContextOptions : this.unPinnedContextOptions;
        this.contextMenu = this.contextMenu.concat(this.defaultContextOptions);
    }

    @HostListener('click', ['$event'])
    showMenu(event: MouseEvent) {
        setTimeout(() => {
            const el: HTMLElement = this.contextMenuRef.el.nativeElement;

            // Get the position of the click relative to the host component
            const rect = this.elRef.nativeElement.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;

            // Set the dropdown position to the new location
            el.style.top = y + 'px';
            el.style.left = x + 'px';

            this.contextMenuRef.toggle(true);
        });
    }

}
